export const FIXED_INDENTS = {
  INDENT_0: '--fixed-indents-0',
  INDENT_5: '--fixed-indents-5',
  INDENT_10: '--fixed-indents-10',
  INDENT_20: '--fixed-indents-20',
  INDENT_21: '--fixed-indents-21',
  INDENT_25: '--fixed-indents-25',
  INDENT_30: '--fixed-indents-30',
  INDENT_40: '--fixed-indents-40',
  INDENT_50: '--fixed-indents-50',
  INDENT_55: '--fixed-indents-55',
  INDENT_60: '--fixed-indents-60',
  INDENT_70: '--fixed-indents-70',
  INDENT_80: '--fixed-indents-80',
  INDENT_90: '--fixed-indents-90',
  INDENT_100: '--fixed-indents-100',
  INDENT_110: '--fixed-indents-110',
  INDENT_120: '--fixed-indents-120',
  INDENT_130: '--fixed-indents-130',
  INDENT_140: '--fixed-indents-140',
  INDENT_150: '--fixed-indents-150',
  INDENT_160: '--fixed-indents-160',
  INDENT_170: '--fixed-indents-170',
  INDENT_180: '--fixed-indents-180',
  INDENT_190: '--fixed-indents-190',
  INDENT_200: '--fixed-indents-200',
  INDENT_210: '--fixed-indents-210',
  INDENT_220: '--fixed-indents-220',
  INDENT_230: '--fixed-indents-230',
  INDENT_240: '--fixed-indents-240',
  INDENT_250: '--fixed-indents-250',
  INDENT_260: '--fixed-indents-260',
  INDENT_270: '--fixed-indents-270',
  INDENT_280: '--fixed-indents-280',
  INDENT_290: '--fixed-indents-290',
  INDENT_300: '--fixed-indents-300',
  INDENT_310: '--fixed-indents-310',
  INDENT_320: '--fixed-indents-320',
  INDENT_330: '--fixed-indents-330',
  INDENT_340: '--fixed-indents-340',
  INDENT_350: '--fixed-indents-350',
  INDENT_360: '--fixed-indents-360',
  INDENT_370: '--fixed-indents-370',
  INDENT_380: '--fixed-indents-380',
  INDENT_390: '--fixed-indents-390',
  INDENT_400: '--fixed-indents-400',
  INDENT_410: '--fixed-indents-410',
  INDENT_420: '--fixed-indents-420',
  INDENT_430: '--fixed-indents-430',
  INDENT_440: '--fixed-indents-440',
  INDENT_450: '--fixed-indents-450',
  INDENT_460: '--fixed-indents-460',
  INDENT_470: '--fixed-indents-470',
  INDENT_480: '--fixed-indents-480',
} as const
export type FIXED_INDENTS = (typeof FIXED_INDENTS)[keyof typeof FIXED_INDENTS]
